var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-b-2 border-grey-lighter lg:border-none"},[_c('HeaderNotice'),_vm._v(" "),_c('HeaderMain',{staticClass:"hidden lg:block"}),_vm._v(" "),_c('HeaderNav',{staticClass:"hidden lg:block"}),_vm._v(" "),_c('HeaderMainMobile',{staticClass:"lg:hidden"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }